var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.list, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g0 = [0, 4].includes(item.type)
    var g1 = g0 ? (item.money / 100).toFixed(2) : null
    var g2 = [1, 2, 3].includes(item.type)
    var g3 = g2 ? (item.money / 100).toFixed(2) : null
    var g4 = [0, 4].includes(item.type)
    return {
      $orig: $orig,
      g0: g0,
      g1: g1,
      g2: g2,
      g3: g3,
      g4: g4,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }